/**
 * A checkout refused because the certified invoice it would produce has no
 * complete recipient (`BILLING_PROFILE_INCOMPLETE`). The portals ask
 * `GET /billing/fiscal/readiness` before a checkout; this answer reaches them
 * only when something changed in between — both read it the same way: open the
 * billing details, with the fields the server names.
 */
import { apiErrorCode, DOMAIN_ERROR_CODES } from '@tonnie/foundation';

export function isBillingProfileIncomplete(err: unknown): boolean {
  return apiErrorCode(err) === DOMAIN_ERROR_CODES.BILLING_PROFILE_INCOMPLETE;
}
